import { Injectable } from '@angular/core';
import { RxProcedureTile } from '@shared/components/rx-procedure-tiles/rx-procedure-tiles.component';
import { map, Observable } from 'rxjs';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { Procedure } from '@shared/models/procedure';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';

@Injectable()
export class ProcedureTilesService {
	private readonly procedures$: Observable<Procedure[]> = this.procedureConfigurationService.procedures$;
	private readonly procedureTilesMapping: Array<Pick<RxProcedureTile, 'Id' | 'Icon'>> = [
		{ Id: ProcedureEnum.StudyModel_iRecord, Icon: 'assets/procedures/study-model.svg' },
		{ Id: ProcedureEnum.Invisalign, Icon: 'assets/procedures/invisalign.svg' },
		{ Id: ProcedureEnum.Appliance, Icon: 'assets/procedures/appliance.svg' },
		{ Id: ProcedureEnum.FixedRestorative, Icon: 'assets/procedures/fixed-restorative.svg' },
		{ Id: ProcedureEnum.Denture_Removable, Icon: 'assets/procedures/dentures.svg' },
		{ Id: ProcedureEnum.ImplantPlanning, Icon: 'assets/procedures/surgical-guide.svg' }
	];

	procedureTiles$: Observable<RxProcedureTile[]> = this.procedures$.pipe(
		map(procedures => procedures.map(procedure => this.mapTile(procedure)))
	);

	mapTile(procedure: Procedure): RxProcedureTile {
		const tile = this.procedureTilesMapping.find(override => override.Id === procedure.Id);

		return {
			...procedure,
			...tile
		};
	}

	constructor(private readonly procedureConfigurationService: ProcedureConfigurationService) {}
}
